import { Box, Button, Fade, FormControlLabel, FormGroup, Grid, InputAdornment, List, ListItem, ListItemIcon, Modal, Switch, TextField, Typography } from '@mui/material';
import MaterialMenu from '../../MaterialMenu.jsx';

import SvgIcon from "@mui/material/SvgIcon";
import { makeStyles } from '@mui/styles';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from "react";
import toast from 'react-hot-toast';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as InputSearchIcon } from "../../../assets/icons/icon-feather-search.svg";
import { ReactComponent as SettingIcon } from "../../../assets/icons/icon-filter-setting-small.svg";
import { ReactComponent as CloseIcon } from "../../../assets/icons/icon_close.svg";

import { ReactComponent as VisualizeIcon } from "../../../assets/icons/icon-visualize.svg";
import { addDashboard, updateDashboard } from '../../../config/services/dashboards.jsx';
import { findMeasureByNameAndDataSetId } from '../../../config/services/measures.jsx';
import { addDashboard as createPublishDashboard, replacePublishDashboard } from '../../../config/services/publishDashboard.jsx';
import { getReportsList } from '../../../config/services/reports.jsx';
import { validateUserRole } from '../../../config/services/role.jsx';
import ReportDashboardSettingSidebar from '../../../layouts/reportDashboard/ReportDashboardSettingSidebar.jsx';
import Loader from "../../../pages/Loader.jsx";
import { applyFilterOnLinkedReports } from '../../../utils/DashboardReusables.jsx';
import { DecryptData, EncryptData } from "../../../utils/encryptDecrypt.jsx";
import getDataFromCube from "../../../utils/getCubeData.jsx";
import FormatControl from '../../_reportDashboardFilter/FormatControl.jsx';
// import DashboardChartLayout from "./DashboardChartLayout.jsx";
import DashboardChartLayoutNew from './DashboardChartLayoutNew.jsx';
import PublishDashboardPopup from './PublishDashboardPopup.jsx';


import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { GREATER_LESS_THAN_FILTER, NUMBER_FILTER_TYPE } from "../../../constants/filterType.jsx";
import { useMeasureListContext } from '../../../contexts/MeasureListContext.jsx';
import { DashboardContextProvider, useDashboardContext } from '../../../layouts/dashboardView/DashboardView.jsx';
import DashboardReportHeaderNew from './DashboardReportHeaderNew.jsx';
import ReportDashboardFilterNew from '../../../pages/ReportDashboardFilterNew.jsx';


const ParseSvgIcon = ({ component }) => <SvgIcon component={component} width={100} height={100} />
const useStyles = makeStyles((theme) => ({
  fieldMenu: {
    boxShadow: '0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)',
  },
  fieldBtn: {
    position: 'absolute',
    right: '5px',
    bottom: '3px',
    cursor: 'pointer',
  },
  reportFieldList: {
    width: '100%',
    backgroundColor: '#fff',
    maxHeight: '350px',
    minHeight: '350px',
    marginBottom: '1rem',
    boxShadow: '0px 3px 6px #00000029',
    overflow: 'auto',
    marginTop: '5px',
    borderRadius: '4px',
  },
  bgWhite: {
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  reportGraphs: {
    height: 'fit-content',
    minHeight: '500px',
    height: '100%',
    backgroundColor: '#f1f1f1',
    padding: '1rem',
    borderRadius: '8px',
    [theme.breakpoints.between("lg", "xl")]: {
      padding: '0.5rem',
    },
    [theme.breakpoints.down("lg")]: {
      padding: '0.5rem',
    },
    [theme.breakpoints.down("sm")]: {
      padding: '0.5rem 0.5rem 0.5rem',
    },
  },
  reportsSelectFilter: {
    background: "#000",
    '&:hover': {
      background: "#f1f1f1",
    },
    '&.MuiFormLabel-root.Mui-focused': {
      color: 'red',
    },
  },
  reportContentWrapper: {
    padding: '0rem',
    marginTop: '0rem',
    [theme.breakpoints.down('lg')]: {
      padding: '0rem',
    },
    ['@media (max-width:1400px)']: {
      padding: '0rem',
    }
  },
  searchFieldListItem: {
    paddingTop: '0.6rem',
    paddingBottom: '0.6rem',
    '&:hover': {
      background: "#f1f1f1",
      zIndex: 9,
    },
  }

}));

function ChartDashboard({ isOpenSidebar, menuItem, onOpenSidebar }) {
  const classes = useStyles();
  const { measureListByDataset, fetchMeasureListByDatasetId } = useMeasureListContext();
  const { dashboardState, currentSheet, addReportToCurrentSheet, removeReportFromCurrentSheet, addNewSheet, updateReportInCurrentSheet, updateSheetFilter } = useDashboardContext();
  const UrlParams = useParams();
  const [layout, setLayout] = useState([[]]);
  const [openPopupPublishDashboard, setOpenPopupPublishDashboard] = useState(false);
  const [openPopupSaveAs, setOpenPopupSaveAs] = useState(false);
  const [duplicateDashName, setDuplicateDashName] = useState('')
  const [duplicateDashDesc, setDuplicateDashDesc] = useState('')
  const [valueList, setValueList] = useState([]);
  const navigate = useNavigate();
  const [sheetsAvailable, setSheetsAvailable] = useState([]);
  const [selectedSheetIndex, setSelectedSheetIndex] = useState(Number(localStorage.getItem('selectedSheetIndex')) || 0);
  const [filterOptions, setFilterOptions] = useState([]);
  const [loader, setLoader] = useState(false)
  const [renewCache, setRenewCache] = useState(true)
  const [granularityOptions, setGranularityOptions] = useState([]);
  const [currentUserType, setCurrentUserType] = useState({});
  useEffect(
    () => {
      validateUserRole()
        .then(res => {
          if (res && res?.userType && res?.userType?.length) {
            setCurrentUserType(res?.userType[0] || {})
          }
        })
    },
    []
  )

  const [editSectionDetails, setEditSectionDetails] = useState(null);

  const { state } = useLocation()
  const bodyRef = React.createRef();


  const saveDashboardHaveChanges = () => {
    let DashboardHaveUnsavedChanges = DecryptData(localStorage.getItem('DashboardHaveUnsavedChanges'))
    if (DashboardHaveUnsavedChanges !== 'true' || DashboardHaveUnsavedChanges !== true) {
      localStorage.setItem('DashboardHaveUnsavedChanges', EncryptData(true))
    }
  }

  const applyGranularityToAllReports = () => {
    let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
    let { reports, sheetGranularities } = sheetsWithoutReference?.[selectedSheetIndex] ?? {}

    let reportWithGranularity = reports?.map(reportObj => {
      let internalPromises = sheetGranularities?.map(async granularity => {
        let { dimension } = granularity
        let dimensionKey = dimension?.split('.')?.[1]
        let measureExistInDataset = await findMeasureByNameAndDataSetId({ dataSetId: reportObj.dataSetId, measureName: dimensionKey })


        if (measureExistInDataset?.exist) {
          let { dataSetId } = measureExistInDataset?.result
          granularity.dimension = `${dataSetId.dataSetName}.${dimensionKey}`
          reportObj.timeDimensions = _.cloneDeep([granularity])
          return reportObj
        }
      })

      return Promise.all(internalPromises)
    })

    return Promise.all(reportWithGranularity)
      .then(res => {
        setSheetsAvailable(sheetsWithoutReference)
      })
  }


  const removeGranularityFrmAllReports = () => {
    let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
    let { reports } = sheetsWithoutReference[selectedSheetIndex]

    reports?.map(reportObj => {
      reportObj.timeDimensions = []
      return reportObj
    })
    sheetsWithoutReference[selectedSheetIndex].sheetGranularities = []

    setSheetsAvailable(sheetsWithoutReference)
  }

  const addGranularityToSheet = (granularity) => {
    let sheetsWithoutReference = _.cloneDeep(sheetsAvailable);
    sheetsWithoutReference[selectedSheetIndex].sheetGranularities = [granularity]
    setSheetsAvailable(sheetsWithoutReference)
  }

  const handleDashboardExport = (e) => {
    window.open(`/dashboardView/${UrlParams?.id}?export=true&ExportSheetIndex=${dashboardState?.currentSheetIndex}`);
  }


  const publishDashboardAPI = async (params) => {
    const { userTypeAccessList, publishActionType, selectedPublishedDashboard, publishDashboardName } = params;

    let { id } = UrlParams
    if (id === "new") {
      toast.error("Save this Dashboard before publish");
      return;
    }

    if (!userTypeAccessList || !userTypeAccessList?.length) {
      toast.error('Please select UserType to Publish Dashboard')
      return
    }

    switch (publishActionType) {
      case 'create':
        addPublishedDashboard({ userTypeAccessList, id, publishDashboardName })
        break
      case 'replace':
        if (!selectedPublishedDashboard) {
          toast.error('Dashboard should be selected!')
          return
        }
        replacePublishedDashboard({ selectedPublishedDashboard, userTypeAccessList, id, publishDashboardName })
        break;
    }
  }

  const addPublishedDashboard = async ({ userTypeAccessList, id, publishDashboardName }) => {
    const params = {
      dashboardId: id,
      dashboardName: publishDashboardName,
      userTypeAccessList: userTypeAccessList
    }
    createPublishDashboard(params).then(response => {
      if (response?.message) {
        toast.success(response?.message)
        setOpenPopupPublishDashboard(false);

      }
      else if (!response?.status?.statusCode) {
        toast.error(response?.data?.error?.errorMessage)
      }
      return response
    });

  }

  const replacePublishedDashboard = ({ selectedPublishedDashboard, userTypeAccessList, id, publishDashboardName }) => {
    const params = {
      dashboardId: selectedPublishedDashboard,
      publishDashboardName: publishDashboardName,
      currentDashboardId: id,
      userTypeAccessList
    }

    replacePublishDashboard(params).then(response => {
      if (response?.message) {
        toast.success(response?.message)
        setOpenPopupPublishDashboard(false);
      }
      else if (!response?.status?.statusCode) {
        toast.error(response?.data?.error?.errorMessage)
      }
      return response
    })
  }

  const handleSubmitPublishDashboard = async (params) => {
    const { type } = params
    if (type === "publish") {
      publishDashboardAPI(params);
    }
    else if (type === 'cancel') {
      setOpenPopupPublishDashboard(false);
    }
  }

  const handlePublishDashboard = () => {
    setOpenPopupPublishDashboard(true);
  }

  const handleMappedSheets = () => {

    let clonedSheeet = _.cloneDeep(dashboardState.sheets)
    let mappedSheets = clonedSheeet.map((sheet, sheetIndex) => {

      if (sheet?.sheetFilter?.length) {
        sheet.sheetFilter = sheet.sheetFilter.map(filterObj => {
          filterObj.reportId = filterObj?.reportObjId
          // filterObj.values = []
          return filterObj
        })
      }
      let dashboardSections = [], reports = []
      sheet.reports?.forEach((report, reportIndex) => {
        if (report?.reportType === 'section') {
          dashboardSections.push({ ...report, reportIndex })
          return
        }
        let _report = {
          reportId: report?._id,
          x: report?.x, //For coordinates of report on canvas
          y: report?.y,
          w: report?.w,
          h: report?.h,
          i: report?.i,
          static: report?.static,
        }
        if (layout && layout[sheetIndex] && layout[sheetIndex][reportIndex]) {
          _report = { ..._report, ...layout[sheetIndex][reportIndex] }
        }
        reports.push(_report);
        return
      })
      sheet.dashboardSections = dashboardSections
      sheet.reports = reports
      return sheet
    })
    return mappedSheets
  }

  const handleSaveDashboard = () => {
    try {
      let { id } = UrlParams
      if (dashboardState.dashboardName && dashboardState.dashboardName.trim() === "") {
        toast.error('Dashboard Name is required')
        return false
      }

      let params = {
        dashboardName: dashboardState.dashboardName,
        dashboardDescription: dashboardState.dashboardDescription,
        settings: {
          notificationBanner: dashboardState.notificationBanner,
          pdfDownloadAllowed: dashboardState.pdfDownloadAllowed,
          tabDesign: dashboardState.tabDesign,
        },
        sheets: JSON.stringify(handleMappedSheets()),
      }
      setSaveLoader(true)

      if (id !== "new") {
        params.dashboardId = id
        updateDashboard(params)
          .then(resp => {
            setSaveLoader(false)
            if (resp?.message) {
              toast.success(resp?.message)
              localStorage.setItem('DashboardHaveUnsavedChanges', EncryptData(false))
              if (state && Object.keys(state)?.length) {
                navigate(window.location.pathname, { replace: true });
              }
            }
            else if (!resp?.status?.statusCode) {
              toast.error(resp?.data?.error?.errorMessage)
            }
          })
          .catch(err => {
            setSaveLoader(false)
          })
      }
      else {
        addDashboard(params)
          .then(resp => {
            setSaveLoader(false)
            if (resp?.message) {
              toast.success(resp?.message)
              localStorage.setItem('DashboardHaveUnsavedChanges', EncryptData(false))
              navigate(`/reportDashboard/${resp?.result?._id}`)
            }
            else if (!resp?.status?.statusCode) {
              toast.error(resp?.data?.error?.errorMessage)
            }
          })
          .catch(err => {
            setSaveLoader(false)
          })
      }
    } catch (error) {
      console.log('save error', error)
    }
  }

  const onLayoutChange = (layoutChange) => {
    let SheetLayout = Array.from(layout)
    SheetLayout[dashboardState.currentSheetIndex] = layoutChange

    if (currentSheet?.reports?.length) {
      currentSheet.reports = currentSheet?.reports?.map((reportDetails, i) => {
        reportDetails.reportId = reportDetails?._id

        if (layoutChange && layoutChange[i])
          reportDetails = { ...reportDetails, ...layoutChange[i] }

        return reportDetails
      })
    }

    setLayout(SheetLayout);
  };

  const containerRef = useRef(null);
  const [saveLoader, setSaveLoader] = useState(false)

  const handleSaveAsPopup = (val) => {
    setOpenPopupSaveAs(val)
  }

  const applyTopBottomToAllReports = async (filterCondition, index) => {
    let sheetsAvailableCloned = _.cloneDeep(sheetsAvailable)


    sheetsAvailableCloned[selectedSheetIndex]?.reports?.map(async (reportObj, reportIndex) => {
      if (reportObj?.measures?.find(measObj => measObj?.fieldName)) {
        reportObj.limit = filterCondition?.limit
        reportObj.orderBy = filterCondition?.order
      }
    })


    return setSheetsAvailable(sheetsAvailableCloned)
  }

  const applyFilterOnAllReport = async (value, indexV, filterArr = undefined, relvantArr = undefined, selectedTimePeriod = undefined) => {
    let valueL = _.cloneDeep(valueList)

    let newArraySheet = await sheetsAvailable[selectedSheetIndex]?.reports?.map(async (obj, index) => {
      let measureList = [];
      let strId = typeof (obj?.dataSetId) === 'object' ? obj?.dataSetId?._id : obj?.dataSetId


      if (!measureListByDataset[strId]) {
        measureList = await fetchMeasureListByDatasetId(strId);
        measureList.map((measure, i) => {
          let filterLength = Number(sheetsAvailable[selectedSheetIndex].sheetFilter?.length);

          for (let j = 0; j < filterLength; j++) {

            if (valueL?.[j] && sheetsAvailable[selectedSheetIndex].sheetFilter[j]) {
              sheetsAvailable[selectedSheetIndex].sheetFilter[j].values = valueL?.[j]
              //Handling Time Period Selected Value
              if (selectedTimePeriod && sheetsAvailable[selectedSheetIndex].sheetFilter[j].dateFilterProps) {
                sheetsAvailable[selectedSheetIndex].sheetFilter[j].dateFilterProps.selectedTimePeriod = selectedTimePeriod
              }
            }


            if (valueL?.length > j && valueL[j]) {

              let dataSetName = null;
              if (obj.dimensions?.length > 0) {
                dataSetName = obj.dimensions[0]?.fieldName?.split('.')[0];
              }
              else if (obj.measures?.length > 0) {
                dataSetName = obj.measures[0]?.fieldName?.split('.')[0];
              }

              if (dataSetName && sheetsAvailable[selectedSheetIndex]?.sheetFilter[j]?.member?.split('.')[1] === measure?.name) {
                let { operator } = sheetsAvailable[selectedSheetIndex]?.sheetFilter[j]

                let objFilter = {
                  operator: operator ?? "equals",
                  values: valueL[j]
                }

                if (sheetsAvailable[selectedSheetIndex].sheetFilter[j]?.applicableTo === 'dataset') {
                  if (sheetsAvailable[selectedSheetIndex].sheetFilter[j]?.member?.split('.')[0] === dataSetName) {
                    objFilter.member = dataSetName + "." + measure?.name;
                  }
                  else {
                    continue;
                  }
                }
                else {
                  objFilter.member = dataSetName + "." + measure?.name;
                }

                let indexF = -1;
                for (let l = obj.reportFilters?.length - 1; l >= 0; l--) {
                  if ((obj.reportFilters[l]?.member?.split(".")[1] === measure?.name) && (obj.reportFilters[l]?.operator === objFilter?.operator)) {
                    indexF = l;
                    break;
                  }
                }

                if (objFilter?.operator === 'top' || objFilter?.operator === 'bottom') {
                  //Do Nothing For current implementation
                }
                else if (indexF >= 0) {
                  obj.reportFilters[indexF].member = objFilter.member;
                  obj.reportFilters[indexF].operator = objFilter.operator;
                  obj.reportFilters[indexF].values = objFilter.values;
                }
                else
                  obj.reportFilters.push(objFilter);
              }
            }
          }
        })
      }
      else {
        measureList = measureListByDataset[strId]
        measureList.map((measure, i) => {
          let filterLength = Number(sheetsAvailable[selectedSheetIndex].sheetFilter?.length);

          for (let j = 0; j < filterLength; j++) {

            if (valueL?.[j] && sheetsAvailable[selectedSheetIndex].sheetFilter[j]) {
              sheetsAvailable[selectedSheetIndex].sheetFilter[j].values = valueL?.[j]
              //Handling Time Period Selected Value
              if (selectedTimePeriod && sheetsAvailable[selectedSheetIndex].sheetFilter[j].dateFilterProps) {
                sheetsAvailable[selectedSheetIndex].sheetFilter[j].dateFilterProps.selectedTimePeriod = selectedTimePeriod
              }
            }
            if (valueL?.length > j && valueL[j]) {

              let dataSetName = null;
              if (obj.dimensions?.length > 0) {
                dataSetName = obj.dimensions[0]?.fieldName?.split('.')[0];
              }
              else if (obj.measures?.length > 0) {
                dataSetName = obj.measures[0]?.fieldName?.split('.')[0];
              }

              if (dataSetName && sheetsAvailable[selectedSheetIndex]?.sheetFilter[j]?.member?.split('.')[1] === measure?.name) {
                let { operator } = sheetsAvailable[selectedSheetIndex]?.sheetFilter[j]

                let objFilter = {
                  operator: operator ?? "equals",
                  values: valueL[j]
                }

                if (sheetsAvailable[selectedSheetIndex].sheetFilter[j]?.applicableTo === 'dataset') {
                  if (sheetsAvailable[selectedSheetIndex].sheetFilter[j]?.member?.split('.')[0] === dataSetName) {
                    objFilter.member = dataSetName + "." + measure?.name;
                  }
                  else {
                    continue;
                  }
                }
                else {
                  objFilter.member = dataSetName + "." + measure?.name;
                }

                let indexF = -1;
                for (let l = obj.reportFilters?.length - 1; l >= 0; l--) {
                  if ((obj.reportFilters[l]?.member?.split(".")[1] === measure?.name) && (obj.reportFilters[l]?.operator === objFilter?.operator)) {
                    indexF = l;
                    break;
                  }
                }


                if (objFilter?.operator === 'top' || objFilter?.operator === 'bottom') {
                  //Do Nothing For current implementation
                }
                else if (indexF >= 0) {
                  obj.reportFilters[indexF].member = objFilter.member;
                  obj.reportFilters[indexF].operator = objFilter.operator;
                  obj.reportFilters[indexF].values = objFilter.values;
                }
                else
                  obj.reportFilters.push(objFilter);
              }
            }
          }
        })
      }

      if (filterArr && relvantArr) {
        let parentFilter = filterArr[0]
        let i = 0;
        for (let filter of sheetsAvailable[selectedSheetIndex]?.sheetFilter) {
          if (relvantArr.includes(filter?.member)) {
            filter.isDisabled = true
            if (parentFilter?.values?.length) {
              filter.relevantValues = []
              let values;
              if (filter?.dynamicLabel) {
                values = await getDataFromCube(filter?.member, filter?.dataSetType, filterArr, "filterDynamicLabel", filter?.dynamicLabel);
              } else {
                values = await getDataFromCube(filter?.member, filter?.dataSetType, filterArr);
              }
              if (filter?.values?.length) {
                filter.values = filter.values.filter(f => f && values?.includes(f))
              }
              filter.relevantValues = values;
              let existVal = values?.filter(v => filter?.values.includes(v))
              filter.values = existVal;
              valueL[i] = existVal
              filter.isDisabled = false
              filter.mode = 'onChange'
            }
            else {
              filter.relevantValues = [];
              filter.values = [];
              valueL[i].length = 0
              filter.isDisabled = false
              filter.mode = 'unSelectAll'
              handleCascadeChild(filter, sheetsAvailable[selectedSheetIndex]?.sheetFilter, valueL)
            }
            sheetsAvailable[selectedSheetIndex].sheetFilter[i] = filter
          }
          i++;
        }
      }

      if (value && indexV >= 0) {
        if (value?.length) {
          valueL[indexV] = value;
        }
        else {
          valueL[indexV].length = 0
        }
        setValueList(valueL);
      }

      if (obj?.linkedReports?.length) {
        obj.linkedReports = await applyFilterOnLinkedReports(obj?.linkedReports, sheetsAvailable[selectedSheetIndex]?.sheetFilter)
      }
    })

    if (newArraySheet?.length) {
      newArraySheet = await Promise.all(newArraySheet);
      let newArray = [...sheetsAvailable];
      setSheetsAvailable(newArray);
      setLoader(false)
    }
  }

  const handleCascadeChild = (filter, sheetFilter, valueL) => {
    if (filter?.useRelevant?.length) {
      let relArr = filter?.useRelevant.map(ele => ele?.relevantMember)
      for (let rel of relArr) {
        let index = sheetFilter?.findIndex(ele => ele?.member === rel)
        if (index >= 0) {
          if (sheetFilter[index]) {
            sheetFilter[index].relevantValues = [];
            sheetFilter[index].values.length = 0;
            sheetFilter[index].isDisabled = false
            sheetFilter[index].mode = 'unSelectAll'
          }
          if (valueL[index])
            valueL[index].length = 0
        }
        if (sheetFilter[index]?.useRelevant?.length) {
          handleCascadeChild(sheetFilter[index], sheetFilter, valueL)
        }
      }
    }
    else
      return
  }


  const addFilterForSheet = (filterObj) => {
    let newArray = sheetsAvailable.map(a => { return { ...a } }) //To prevent call by refference
    let NewValueList = valueList.map(a => { return [...a] })
    if (newArray && newArray.length > 0) {
      newArray[selectedSheetIndex]?.sheetFilter?.push(filterObj);
      NewValueList.push(filterObj.values)
      setValueList(NewValueList)
      setSheetsAvailable(newArray);
      saveDashboardHaveChanges()
    }
  }

  const handleHideDashboardFilter = (filter, index, valueList) => {
    if (sheetsAvailable?.length && sheetsAvailable[selectedSheetIndex]?.sheetFilter?.length) {
      sheetsAvailable[selectedSheetIndex]?.sheetFilter?.forEach(element => {
        if (element?._id === filter?._id) {
          element?.hidden === true ? element.hidden = false : element.hidden = true
        }
      });
    }
  }

  const handleDeleteDashboardFilter = (filter, index, valueList) => {
    /**  To remove all filters from all reports **/
    removeFiltersFromAllSheetByValue(filter)

    if (sheetsAvailable?.length && sheetsAvailable[selectedSheetIndex]?.sheetFilter?.length) {
      let sheetFilter = sheetsAvailable[selectedSheetIndex].sheetFilter;

      let sheetFilterN = [...sheetFilter]
      sheetFilterN.splice(index, 1)

      let valueListN = Array.from(valueList)
      valueListN.splice(index, 1)
      setValueList(valueListN);

      sheetsAvailable[selectedSheetIndex].sheetFilter = sheetFilterN;
      let newArray = [...sheetsAvailable];
      setSheetsAvailable(newArray);
    }

    saveDashboardHaveChanges()
  }

  const removeFiltersFromAllSheetByValue = (filterRemoved) => {
    let { values } = filterRemoved

    sheetsAvailable[selectedSheetIndex]?.reports.map(report => {
      report?.reportFilters?.map(reportFilter => {

        if (reportFilter?.reportId?._id) {
          reportFilter.reportId = reportFilter?.reportId?._id
        }

        if (reportFilter?.values)
          reportFilter.values = reportFilter?.values?.filter(val => val !== values?.[0])
      })
    })
  }

  useEffect(() => applyFilterOnAllReport(), [valueList])

  const handleEditDashboardFilter = (form) => {
    if (form && sheetsAvailable?.length && sheetsAvailable[selectedSheetIndex]?.sheetFilter?.length) {
      sheetsAvailable[selectedSheetIndex].sheetFilter[form?.index].applicableTo = form?.applicableTo;
      sheetsAvailable[selectedSheetIndex].sheetFilter[form?.index].applyTo = form?.applyTo;
      sheetsAvailable[selectedSheetIndex].sheetFilter[form?.index].displayNameOnSheet = form?.displayNameOnSheet;
      sheetsAvailable[selectedSheetIndex].sheetFilter[form?.index].displayType = form?.displayType;
      let newArray = [...sheetsAvailable];
      setSheetsAvailable(newArray);
      applyFilterOnAllReport();
    }
  }

  const handleDuplicateDashboard = async () => {
    if (!duplicateDashName) { toast.error('Dashboard Name is required'); }

    const params = {
      dashboardName: duplicateDashName,
      dashboardDescription: duplicateDashDesc,
      sheets: JSON.stringify(handleMappedSheets())
    }

    setSaveLoader(true)
    const resp = await addDashboard(params)
    setSaveLoader(false)
    if (resp?.message) {
      toast.success(resp?.message)
      navigate(`/dashboard`)
    }
    else if (!resp?.status?.statusCode) {
      toast.error(resp?.data?.error?.errorMessage)
    }

    handleSaveAsPopup(false)
  }

  const handleRemoveSection = (report) => {
    removeReportFromCurrentSheet(report)
  }

  const handleEditSection = (l) => {
    setEditSectionDetails({ title: l?.reportName, description: l?.description, id: l?.id, mode: 'edit', hasHRLine: l?.hasHRLine })
  }

  const handleDashboardPreview = () => {
    const data = {
      dashboardName: dashboardState?.dashboardName,
      sheets: dashboardState?.sheets,
      dashboardDescription: dashboardState?.dashboardDescription,
      dashboardUpdatedAt: dashboardState?.dashboardUpdatedAt,
      dashboardId: UrlParams?.id,
      tabDesign: dashboardState?.tabDesign,
      notificationBanner: dashboardState?.notificationBanner,
      pdfDownloadAllowed: dashboardState?.pdfDownloadAllowed,
      currentSheetIndex: dashboardState?.currentSheetIndex,
      dashboardShareState: dashboardState?.dashboardShareState,
      isDeactivated: dashboardState?.isDeactivated,
    }
    navigate(`/dashboardView/${UrlParams?.id || 'new'}`, { state: data })
  }

  if (dashboardState?.loading) return <Loader />

  return (
    <Box width="100%" height="100%" className={classes.reportContentWrapper} sx={{ padding: '2rem', marginTop: '0rem' }}>
      {dashboardState.loading && <Loader />}
      <DashboardReportHeaderNew
        onSaveLoader={saveLoader}
        currentUserType={currentUserType}
        onhandleSaveDashboard={handleSaveDashboard}
        handleDashboardPreview={handleDashboardPreview}
        handleSaveAsPopup={handleSaveAsPopup}
        handlePublishDashboard={handlePublishDashboard}
        onOpenSidebar={onOpenSidebar}
        handleDashboardExport={handleDashboardExport}
        setRenewCache={setRenewCache}
        renewCache={renewCache}
      />
      {/* <div className="sheet-container" >
        <div>
          <DashboardSheets />
        </div>
        <AddSectionButtonComponent
          currentSheet={currentSheet}
          editSectionDetails={editSectionDetails}
          setEditSectionDetails={setEditSectionDetails}
          addReportToCurrentSheet={addReportToCurrentSheet}
          updateReportInCurrentSheet={updateReportInCurrentSheet}
        />
      </div> */}
      {/* <Box sx={{ marginBottom: '10px' }}>
        <DashboardSheetFilter editFilterComponents={editFilterComponents({ currentSheet, dashboardState, updateSheetFilter })} />
      </Box> */}
      <Grid container spacing={2} className="report-new-content dashboard-reports" sx={{ mt: 0 }} >
        <Grid item xs={12} md={isOpenSidebar ? 4 : 0} className="report-new-main-fields" alignItems="stretch"
          sx={{ paddingTop: '0px !important', display: (isOpenSidebar) ? 'block' : 'none' }} >
          {isOpenSidebar ?
            ((menuItem == 'Visualize') ?
              <ReportDashboardSettingSidebar isOpenSidebar={isOpenSidebar}
                children={
                  <DashboardVisualizeSettings
                    addReportToCurrentSheet={addReportToCurrentSheet}
                    removeReportFromCurrentSheet={removeReportFromCurrentSheet}
                    currentSheet={currentSheet}
                  />
                }
              />
              :
              <ReportDashboardSettingSidebar
                isOpenSidebar={isOpenSidebar}
                children={<ReportDashboardFilterNew
                  handleEditDashboardFilter={handleEditDashboardFilter}
                  valueList={valueList}
                  applyFilterOnAllReport={applyFilterOnAllReport}
                  addFilterForSheet={addFilterForSheet}
                  filterOptions={filterOptions}
                  granularityOptions={granularityOptions}
                  addGranularityToSheet={addGranularityToSheet}
                  sheetsAvailable={sheetsAvailable}
                  setSheetsAvailable={setSheetsAvailable}
                  selectedSheetIndex={selectedSheetIndex}
                  removeGranularityFrmAllReports={removeGranularityFrmAllReports}
                  applyGranularityToAllReports={applyGranularityToAllReports}
                />}
              />) :
            (null)}
        </Grid>

        <Grid item xs={12} md={isOpenSidebar ? 8 : 12} className="report-new-main-content" alignItems="stretch" sx={{ paddingTop: '0px !important' }} >
          <Box ref={containerRef} className={classes.reportGraphs} sx={{p: '15px !important'}}>
            {
              !dashboardState.loading ?
                <DashboardChartLayoutNew
                  onLayoutChange={onLayoutChange}
                  selectedReports={currentSheet?.reports ?? []}
                  bodyRef={bodyRef}
                  handleSelectReport={removeReportFromCurrentSheet}
                  renewCache={renewCache}
                  handleEditSection={handleEditSection}
                  handleRemoveSection={handleRemoveSection}
                  measureListByDataset={measureListByDataset}
                  fetchMeasureListByDatasetId={fetchMeasureListByDatasetId}
                  isOpenSidebar={isOpenSidebar}
                  editFilterComponents={editFilterComponents}
                  currentSheet={currentSheet}
                  dashboardState={dashboardState}
                  updateSheetFilter={updateSheetFilter}
                />
                : null
            }
          </Box>
        </Grid>
      </Grid>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={openPopupPublishDashboard}
        closeAfterTransition
      >
        <Fade in={openPopupPublishDashboard}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title" >{`Publish`}</Typography>
            </Box>
            <Box className="modal-content">
              <PublishDashboardPopup dashboardId={UrlParams?.id} handleSubmitPublishDashboard={handleSubmitPublishDashboard}
                dashboardName={dashboardState.dashboardName} />
            </Box>
          </Box>
        </Fade>
      </Modal>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={openPopupSaveAs}
        closeAfterTransition
      >
        <Fade in={openPopupSaveAs}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title" >{`Save dashboard as`}</Typography>
            </Box>
            <Box className="modal-content">
              <Typography className="text-small label" variant="p">Enter Dashboard Name</Typography>
              <TextField onChange={(e) => setDuplicateDashName(e?.target?.value)} value={duplicateDashName} className="report_form_ui_input width-100 mb-1" placeholder="" /> <br />
              <Typography className="text-small label" variant="p">Enter Dashboard Description</Typography>
              <TextField value={duplicateDashDesc} onChange={(e) => setDuplicateDashDesc(e?.target?.value)} className="report_form_ui_input width-100" placeholder="" />

              <Box className="modal-footer text-right">
                <Button onClick={e => handleSaveAsPopup(false)} color="error" className="report_form_ui_btn mr-2 cancel" variant="outlined" > Cancel </Button>
                <Button onClick={handleDuplicateDashboard} color="primary" autoFocus className="report_form_ui_btn submit" variant="contained"> Save </Button>
              </Box>
            </Box>

          </Box>
        </Fade>
      </Modal>
    </Box>
  );
}

export default function (props) {
  return (
    <DashboardContextProvider isEditDashboardPage>
      <ChartDashboard {...props} />
    </DashboardContextProvider>
  )
}

function useReportList() {
  const [reportListState, setReportListState] = useState({
    loading: false,
    error: null,
    reportList: [],
    isSeachedReportList: false,
    searchedReportList: []
  });

  useEffect(() => fetchReports({ pageNo: 0, searchText: null }), []);

  function fetchReports({ pageNo = 0, searchText = null }) {
    if ((searchText === null || searchText === undefined || searchText === '') && reportListState.reportList.length > 0) {
      setReportListState(prev => ({ ...prev, isSeachedReportList: false, searchedReportList: [] }))
      return
    }
    setReportListState(prev => ({ ...prev, loading: true }))
    getReportsList({ pageNo: pageNo, search: searchText })
      .then(res => {
        let reportsList = res?.result?.map(report => {
          report.label = report.reportName
          report.value = report._id
          return report
        })
        setReportListState(prev => ({
          ...prev,
          reportList: !searchText ? reportsList : prev.reportList,
          isSeachedReportList: !!searchText,
          searchedReportList: searchText ? reportsList : prev.searchedReportList
        }))
      })
      .catch(err => {
        setReportListState(prev => ({ ...prev, error: err }))
      })
      .finally(() => {
        setReportListState(prev => ({ ...prev, loading: false }))
      })
  }

  return { reportListState, fetchReports }
}

function DashboardVisualizeSettings({ addReportToCurrentSheet, removeReportFromCurrentSheet, currentSheet }) {
  const classes = useStyles();
  const { reportListState, fetchReports } = useReportList();

  const handleSearchReport = _.debounce((e) => {
    let { value } = e.target
    fetchReports({ searchText: value });
  }, 400);

  const setClassNameReport = (report) => {
    let SheetIndex = currentSheet?.reports?.findIndex(itm => itm._id === report._id)

    if (SheetIndex < 0)
      return ""
    else
      return "visualize_list_text"
  }
  function handleOnReportClick(report) {
    const reportIndexInCurrentSheet = currentSheet?.reports?.findIndex(_report => _report._id === report._id)
    if (reportIndexInCurrentSheet >= 0) {
      removeReportFromCurrentSheet(report)
      return
    }
    addReportToCurrentSheet({ report })
  }
  return (
    <Box width="100%" height="100%">
      <Typography className="report-form-label font-weight-normal" variant="subtitle1" display="block"> Reports </Typography>

      <TextField className="cm_rprt_setting_content report_form_ui_input dashboard_input_reports pl-0" type="search" size="small" placeholder="Search Report"
        onChange={handleSearchReport}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" className="">
              <InputSearchIcon className="input_search_icon" />
            </InputAdornment>
          ),
          classes: {
            adornedStart: classes.bgWhite + " input_search_icon_box"
          }
        }} />

      <div className={classes.reportFieldList + " dashboard_reports_list"}>
        <List component="nav" mt={2} >
          {
            (reportListState.searchedReportList?.length > 0 || reportListState.reportList?.length > 0)
              ? (reportListState.isSeachedReportList ? reportListState.searchedReportList : reportListState.reportList)?.map((report, i) => {
                return (
                  <ListItem key={i} button onClick={(e) => handleOnReportClick(report, e)} className={setClassNameReport(report) + " " + classes.searchFieldListItem}
                    alignItems="flex-start">
                    <ListItemIcon sx={{ mt: '4px', mr: '4px' }}> <ParseSvgIcon component={VisualizeIcon} /> </ListItemIcon>
                    <Grid container >
                      <Grid item xs={12}>
                        <Typography variant="body2" className="text-plain"> {report.reportName} </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" className="text-sub"> {report.description ?? 'No description'} </Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                )
              })
              : null
          }
        </List>
      </div>
    </Box>
  )
}

function AddSectionButtonComponent({
  currentSheet,
  editSectionDetails,
  setEditSectionDetails,
  addReportToCurrentSheet,
  updateReportInCurrentSheet
}) {
  const [openAddSection, setOpenAddSection] = useState(false);
  const [sectionDetails, setSectionDetails] = useState({});
  useEffect(() => {
    if (editSectionDetails && editSectionDetails?.mode === 'edit') {
      setSectionDetails({ ...editSectionDetails })
      setOpenAddSection(true)
    }
  }, [editSectionDetails])
  const descriptionRef = React.useRef();
  function handleSectionDetailsChange(event) {
    setSectionDetails(prev => ({ ...prev, [event?.target?.name]: event?.target?.value }))
  }
  function handleDescriptionChange(value) {
    setSectionDetails(prev => ({ ...prev, description: value }))
  }
  function handleSectionLineChange(event) {
    setSectionDetails(prev => ({ ...prev, [event?.target?.name]: event?.target?.checked }))
  }
  function handleCancelSection() {
    setSectionDetails({})
    setOpenAddSection(false)
  }
  function handleCharacterLimit(event) {
    const editorContext = descriptionRef.current.unprivilegedEditor;
    if (editorContext.getLength() > 150 && event.key !== 'Backspace')
      event.preventDefault();
  };
  function handleSaveSection() {

    if (!sectionDetails?.title || sectionDetails?.title.trim().length === 0) {
      toast.error('Section Title is required');
      return
    }

    if (!sectionDetails?.title || sectionDetails?.title.trim().length > 80) {
      toast.error('Title field character limit is maximum 80 characters');
      return
    }

    const editorContext = descriptionRef.current.unprivilegedEditor;

    if (editorContext.getText().length > 1) {
      if (editorContext.getText().split(/\r\n|\r|\n/).length > 4) {
        toast.error('Section Description exceeded max number of lines(3)');
        return
      }

      let editorContextVal = editorContext.getText().replace(/<p><br[\/]?><[\/]?p>/g, '');

      if (editorContextVal.trim().length > 0 && editorContextVal.trim().length > 150) {
        toast.error('Description field character limit is maximum 150 characters');
        return
      }

      if (editorContextVal.trim().length > 150) {
        toast.error('Description field character limit is maximum 150 characters');
        return
      }
    }

    if (sectionDetails?.mode === 'edit') {
      let section = currentSheet?.reports?.find(section => section?.id === sectionDetails?.id)
      if (section) {
        section.reportName = sectionDetails?.title
        section.description = sectionDetails?.description
        section.hasHRLine = sectionDetails?.hasHRLine

        updateReportInCurrentSheet({ report: section });
        setSectionDetails({})
        setEditSectionDetails(null);
        setOpenAddSection(false)
        return
      }
    }

    let section = {
      id: Math.random().toString(16).slice(2),
      reportName: sectionDetails?.title,
      description: sectionDetails?.description,
      hasHRLine: sectionDetails?.hasHRLine,
      reportType: 'section'
    }
    addReportToCurrentSheet({ report: section });
    setOpenAddSection(false)
    setSectionDetails({})
  }
  return (
    <>
      <Button
        variant="outlined"
        className="re-dashboard-new-btn-outline"
        onClick={() => setOpenAddSection(true)}
      >
        Add Section
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root re-modal"
        open={openAddSection}
        closeAfterTransition
      >
        <Fade in={openAddSection}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-header border-0" >
              <Typography variant="subtitle1" className="modal-header-title" >{`Add Section`}</Typography>
            </Box>
            <Box className={`modal-content re-modal-content `}>
              <TextField
                name="title"
                required={true}
                placeholder="Title"
                defaultValue={sectionDetails?.title}
                onChange={handleSectionDetailsChange}
                className="report_form_ui_input width-100 mb-1"
              />
              <br />
              <Typography className="text-small label new-dasboard-modal-editor-label" variant="p">Description</Typography>
              <ReactQuill
                theme="snow"
                modules={{ toolbar: [["bold", "italic", "underline"], [{ 'list': 'ordered' }, { 'list': 'bullet' }],], }} placeholder={''}
                value={sectionDetails?.description}
                onChange={handleDescriptionChange}
                onKeyDown={handleCharacterLimit}
                ref={descriptionRef}
              />
              <Typography variant="p" className="new-dasboard-modal-editor-helper-text">
                The character limit will be 150.
              </Typography>

              <FormGroup>
                <FormControlLabel
                  className="text-plain"
                  control={
                    <Switch
                      name='hasHRLine'
                      onChange={handleSectionLineChange}
                      checked={sectionDetails?.hasHRLine} />
                  }
                  label="Show Horizontal Line" />
              </FormGroup>


              <Box className="modal-footer text-right">
                <Button onClick={handleCancelSection} color="error" className="re-btn re-btn-outline re-btn-separator cancel" variant="outlined" > Cancel </Button>
                <Button onClick={handleSaveSection} color="primary" autoFocus className="re-btn re-btn-main submit" variant="contained"> Save </Button>
              </Box>
            </Box>

          </Box>
        </Fade>
      </Modal>
    </>
  )
}

function editFilterComponents({ currentSheet, dashboardState, updateSheetFilter }) {
  return Array.from(currentSheet?.sheetFilter ?? [])
    .map((filter, index) => (
      <FilterEditComponent key={`dashboard-edit-filter-${filter.member}`} updateSheetFilter={updateSheetFilter} dashboardState={dashboardState} currentSheet={currentSheet} filter={filter} index={index} />
    ))
}

function FilterEditComponent({ filter, index, dashboardState, currentSheet, updateSheetFilter }) {
  const [isDeletePopupOpen, setIsDeletePopupOpen] = useState(false);
  const [isHidePopupOpen, setIsHidePopupOpen] = useState(false);
  const [isEditFilterPopupOpen, setIsEditFilterPopupOpen] = useState(false);
  function handleDeleteFilter() {
    let sheetFilter = structuredClone(currentSheet.sheetFilter);
    sheetFilter.splice(index, 1)
    updateSheetFilter({ sheetFilter, sheetIndex: dashboardState.currentSheetIndex });
    setIsDeletePopupOpen(false);
  }
  function handleHideFilter() {
    let sheetFilter = structuredClone(currentSheet.sheetFilter);
    sheetFilter[index].hidden === true ? sheetFilter[index].hidden = false : sheetFilter[index].hidden = true
    updateSheetFilter({ sheetFilter, sheetIndex: dashboardState.currentSheetIndex, metaDataOnly: true });
    setIsHidePopupOpen(false);
  }
  function addOrEdit(form, resetForm) {
    resetForm()
    setIsEditFilterPopupOpen(false);
    if (form) {
      let sheetFilter = structuredClone(currentSheet.sheetFilter);
      sheetFilter[form?.index].applicableTo = form?.applicableTo;
      sheetFilter[form?.index].applyTo = form?.applyTo;
      sheetFilter[form?.index].displayNameOnSheet = form?.displayNameOnSheet;
      sheetFilter[form?.index].displayType = form?.displayType;
      updateSheetFilter({ sheetFilter, sheetIndex: dashboardState.currentSheetIndex, metaDataOnly: true });
    }
  }
  let FilterMenuOptions = [
    { label: 'Edit', func: () => setIsEditFilterPopupOpen(true) },
    { label: 'Delete', func: () => setIsDeletePopupOpen(true) },
    { label: filter?.hidden === true ? 'Unhide' : "Hide", func: () => setIsHidePopupOpen(true) }
  ]
  const getFilterLabel = () => {
    let { displayName, operator, displayNameOnSheet, member, listType } = filter
    let FilterLabel = displayNameOnSheet || displayName || member?.split('.')[1]

    if (GREATER_LESS_THAN_FILTER.includes(operator) && listType === 'inputValue') {
      return `${FilterLabel} ${NUMBER_FILTER_TYPE[operator]}`;
    }

    return `${FilterLabel}`
  }
  return (
    <>
      <Box sx={{ display: 'flex', mb: '6px', alignItems:'center' }}>
        <Box sx={{ fontSize: '14px', fontWeight: '600' }}>{getFilterLabel()}</Box>
        <MaterialMenu icon={<SettingIcon />} options={FilterMenuOptions} onClose={() => { return false }} />
      </Box>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={isDeletePopupOpen}
        onClose={() => setIsDeletePopupOpen(false)}
        closeAfterTransition
      >
        <Fade in={isDeletePopupOpen}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple">{`Are you sure to delete this dashboard ?`}</Typography>
              <Box className="modal-footer-simple">
                <Button onClick={() => setIsDeletePopupOpen(false)} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={handleDeleteFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> Delete </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={isHidePopupOpen}
        onClose={() => setIsHidePopupOpen(false)}
        closeAfterTransition
      >
        <Fade in={isHidePopupOpen}>
          <Box className="modal-paper modal-box modal-sm" id="transition-modal-title">
            <Box className="modal-content-simple">
              <Typography variant="subtitle1" className="modal-heading-title-simple"> {`Are you sure you want to ${filter?.hidden === true ? `unhide` : `hide`}  this filter ?`}</Typography>
              <Box className="modal-footer-simple">
                <Button onClick={() => setIsHidePopupOpen(false)} color="primary" className="report_form_ui_btn cancel mr-2" variant="outlined" > Cancel </Button>
                <Button onClick={handleHideFilter} color="error" autoFocus className="report_form_ui_btn submit" variant="contained"> {filter?.hidden === true ? 'Unhide' : 'Hide'} </Button>
              </Box>
            </Box>
          </Box>
        </Fade>
      </Modal>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className="modal-root"
        open={isEditFilterPopupOpen}
        onClose={() => setIsEditFilterPopupOpen(false)}
        closeAfterTransition
      >
        <Fade in={isEditFilterPopupOpen}>
          <Box className="modal-paper modal-box modal-md" id="transition-modal-title">
            <CloseIcon onClick={() => setIsEditFilterPopupOpen(false)} className="enlarge-close" />
            <Box className="modal-header" >
              <Typography variant="subtitle1" className="modal-header-title" >{`Edit Filter`}</Typography>
            </Box>
            <Box className="modal-content">
              <FormatControl
                addOrEdit={addOrEdit}
                recordForEdit={{ ...filter, index }}
              />
            </Box>

          </Box>
        </Fade>
      </Modal>
    </>
  )
}